/* eslint-disable no-useless-escape */
import useLocales from 'src/hooks/useLocales';
import moment from 'moment';

export const ConstantType = () => {
  const { translate } = useLocales();

  const addressTypes = [
    {
      value: 'main',
      label: translate('common.addressTypes.main'),
    },
    {
      value: 'branch',
      label: translate('common.addressTypes.branch'),
    },
    {
      value: 'shipping',
      label: translate('common.addressTypes.shipping'),
    },
    {
      value: 'billing',
      label: translate('common.addressTypes.billing'),
    },
  ];

  const months = [
    { value: '1', label: translate('common.months.january') },
    { value: '2', label: translate('common.months.february') },
    { value: '3', label: translate('common.months.march') },
    { value: '4', label: translate('common.months.april') },
    { value: '5', label: translate('common.months.may') },
    { value: '6', label: translate('common.months.june') },
    { value: '7', label: translate('common.months.july') },
    { value: '8', label: translate('common.months.august') },
    { value: '9', label: translate('common.months.september') },
    { value: '10', label: translate('common.months.october') },
    { value: '11', label: translate('common.months.november') },
    { value: '12', label: translate('common.months.december') },
  ];

  const getPayPeriodStatus = [
    { value: 'active', label: 'Active' },
    { value: 'deactive', label: 'Deactive' },
  ];

  const renderMonthName = (month) => {
    const monthName = months?.find((m) => m.value === month);
    return monthName ? monthName?.label : '';
  };

  const defaultImages = {
    url: '',
  };

  const defaultAddress = {
    type: 'default',
    address: '',
    landmark: '',
    country_id: '',
    state_id: '',
    city_id: '',
    code: '',
  };

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return {
    months,
    addressTypes,
    defaultImages,
    defaultAddress,
    renderMonthName,
    passwordRegex,
    emailRegex,
    getPayPeriodStatus,
  };
};

export const blockInvalidChar = (e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();

export const TagType = ['document', 'equipment', 'fleet', 'inventory', 'job', 'location', 'resource', 'toolkit'];

export const EmptyUrlFilter = (value = []) => {
  const out = value.filter(function (el) {
    return el.url != '';
  });
  return out;
};

export function compareCheckInOut(checkOut, checkIn) {
  const momentA = moment(checkOut, 'YYYY-MM-DD hh:mm:ss a');
  const momentB = moment(checkIn, 'YYYY-MM-DD hh:mm:ss a');
  const Hrs_12 = momentA.subtract(momentB).format('H:mm:ss');
  if (momentA > momentB) return 1;
  else if (momentA == momentB) return -1;
  else if (Hrs_12 === '17:30:00') return -2;
  else return 0;
}

export function getHoursAndMin(checkIn, checkOut) {
  const startTime = moment(checkIn, 'YYYY-MM-DD hh:mm:ss a');
  const endTime = moment(checkOut, 'YYYY-MM-DD hh:mm:ss a');
  const totalSec = endTime.diff(startTime, 'seconds');
  const result2 = moment().startOf('day').seconds(totalSec).format('H:mm');
  return result2;
}

export const UIDRegex = /^[a-zA-Z0-9.-]{2,}-[0-9.-]*$/;
export const NumberRegex = /^\d+$/;
export const FloatNumberRegex = /^\d+(\.\d+)?$/;
export const UIDCompanyRegex = /^[a-zA-Z0-9.-]*$/;

export const validateMobileNumber = (input) => {
  var re = /^(\d{3})[- ]?(\d{3})[- ]?(\d{4})$/;
  return re.test(input);
};

export const InOut = [
  { label: 'In', value: 'in' },
  { label: 'Out', value: 'out' },
];

export const referenceTypes = [
  {
    label: 'Location',
    value: 'location',
  },
  {
    label: 'Customer',
    value: 'customer',
  },
  {
    label: 'Vendor',
    value: 'vendor',
  },
  {
    label: 'Company',
    value: 'company',
  },
];

export const fuelUsageReferenceTypes = [
  {
    label: 'Equipment',
    value: 'E',
  },
  {
    label: 'Job',
    value: 'J',
  },
  {
    label: 'Inventory',
    value: 'I',
  },
  {
    label: 'Customer',
    value: 'C',
  },
  {
    label: 'Vendor',
    value: 'V',
  },
];

export const commonReferenceTypes = [
  {
    label: 'Job',
    value: 'job',
  },
  {
    label: 'Customer',
    value: 'customer',
  },
];

export const isCustomreferenceTypes = [
  {
    label: 'Location',
    value: 'location',
  },
  {
    label: 'Company',
    value: 'company',
  },
];

export const workCardTypes = [
  {
    label: 'Job',
    value: 'J',
  },
  {
    label: 'Equipment',
    value: 'E',
  },
  {
    label: 'Payroll',
    value: 'P',
  },
  {
    label: 'Services',
    value: 'S',
  },
];

export const WorkTypeFilter = [
  {
    label: 'Job',
    value: 'J',
  },
  {
    label: 'Equipment',
    value: 'E',
  },
];

export const workCardMode = [
  {
    label: 'Check In',
    value: 'check_in',
  },
  {
    label: 'Check Out for Break',
    value: 'out_break',
  },
  {
    label: 'Check In after Break',
    value: 'in_break',
  },
  {
    label: 'Check Out',
    value: 'check_out',
  },
];
export const TrackStatus = [
  {
    label: 'Partial',
    value: 'partial',
  },
  {
    label: 'Unacceptable',
    value: 'unacceptable',
  },
  {
    label: 'Others',
    value: 'others',
  },
];

export const TrackTypes = [
  {
    label: 'Inventory',
    value: 'inventory',
  },
  {
    label: 'Vendor',
    value: 'vendor',
  },
];

export const ObtainedType = [
  {
    value: 'training_class',
    label: 'Training Class',
  },
  {
    value: 'prior_to_hiring',
    label: 'Prior to Hiring',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

export const AttachmentModules = [
  {
    value: 'faq',
    label: 'FAQ',
  },
  {
    value: 'skill',
    label: 'Skills',
  },
  {
    value: 'training',
    label: 'Training',
  },
  {
    value: 'ticket',
    label: 'Ticket',
  },
  {
    value: 'resource',
    label: 'Resource',
  },
  {
    value: 'document',
    label: 'Document',
  },
];

export const TotalTimeCal = (startTime, endTime) => {
  const startSplit = startTime.split(' ');
  const endSplit = endTime.split(' ');
  const start = moment(`${startSplit[1]} ${startSplit[2]}`, 'hh:mm a');
  const end = moment(`${endSplit[1]} ${endSplit[2]}`, 'hh:mm a');
  const hours = moment.duration(moment(end, 'HH:mm A').diff(moment(start, 'HH:mm A')));
  const getTime = [hours.hours(), hours.minutes()].join(':');
  return getTime;
};

export const CheckString = (string) => {
  const smallCase = string?.toLowerCase();
  let substring = ['hours', 'hour', 'hours/hour'];
  const contains = substring.some((element) => {
    if (smallCase?.includes(element)) {
      return true;
    }
    return false;
  });
  return contains;
};

export const userTypeData = [
  {
    value: 'employee',
    label: 'Employee',
  },
  {
    value: 'user',
    label: 'User',
  },
];

export const workCardStatuses = [
  {
    label: 'Rejected',
    value: 'rejected',
  },
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Revise',
    value: 'revise',
  },
];

export const equipmentWorkCardStatuses = [
  {
    label: 'Rejected',
    value: 'rejected',
  },
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Revise',
    value: 'revise',
  },
];
export const FilterWorkCardStatuses = [
  {
    label: 'Rejected',
    value: 'rejected',
  },
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
];
export const getWorkType = (value) => {
  let workType = '-';
  switch (value) {
    case 'J':
      workType = 'Job';
      break;
    case 'E':
      workType = 'Equipment';
      break;
    case 'S':
      workType = 'Services';
      break;
    case 'P':
      workType = 'payroll';
      break;
    default:
      workType = '-';
      break;
  }
  return workType;
};

export const AlphabeticPattern = /[a-zA-Z]/;
export const SpecialRegex = /[~!@#$%^&*()_\-+=\\|{}[\]:;"'<>,.`/?*]/;

export const RenderMonth = (value) => {
  const val = parseInt(value);
  const months = [
    { value: '1', label: "January" },
    { value: '2', label: "February" },
    { value: '3', label: "March" },
    { value: '4', label: "April" },
    { value: '5', label: "May" },
    { value: '6', label: "June" },
    { value: '7', label: "July" },
    { value: '8', label: "August" },
    { value: '9', label: "September" },
    { value: '10', label: "October" },
    { value: '11', label: "November" },
    { value: '12', label: "December" },
  ];
  const out = months?.map((item, index) => {
    if(parseInt(item?.value) === val) {
      return item?.label
    }
  })
  return out;
}
